import React from "react";
import fp from "lodash/fp";
import { useDispatch, useSelector } from "react-redux";

import { Alert } from "components";
import { uiActions } from "store";
import { getAlerts } from "store/ui/ui.reducer";

import styles from "./alertManager.module.scss";

const AlertManager = () => {
	const dispatch = useDispatch();
	const alerts = useSelector(getAlerts) || {};

	return (
		<div className={styles.topAlertContainer}>
			{fp.flow(
				fp.filter("show"),
				(alerts: any[]) =>
					alerts &&
					alerts.map((alert, i) => {
						const handleHide = () => {
							dispatch(uiActions.hideNotification(alert.title));
						};

						return (
							<Alert
								variant={alert.variant}
								message={alert.title}
								onClose={handleHide}
								className={styles.topAlert}
								centered
								key={alert.variant + i}
							/>
						);
					}),
			)(alerts)}
		</div>
	);
};

export default AlertManager;
